import { getAnalytics } from "@/observability/analytics/bootstrap";

/**
 * tutorial_* events. AnalyticsService.track() already respects the admin
 * analytics toggle and buffers until PostHog is ready, so this is a thin
 * namespacing helper that can never throw into UI code.
 */
export const trackTutorialEvent = (eventName, properties = {}) => {
  try {
    const name = eventName.startsWith("tutorial_") ? eventName : `tutorial_${eventName}`;
    getAnalytics().track(name, properties);
  } catch {
    /* analytics must never break the UI */
  }
};
